import React, { useState } from 'react';
import { Menu, TreePine } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { label: 'Details', href: '#details', testId: 'nav-link-details' },
    { label: 'Accommodation', href: '#accommodation', testId: 'nav-link-accommodation' },
    { label: 'Gallery', href: '#gallery', testId: 'nav-link-gallery' },
    { label: 'Upload', href: '#upload', testId: 'nav-link-upload' },
  ];

  const handleNavClick = (href) => {
    setIsOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 350);
    } else {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLogoClick = () => {
    setIsOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="section-container py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={handleLogoClick}
            data-testid="nav-logo-home-button"
            className="text-xl font-serif font-semibold text-foreground hover:text-primary transition-colors focus-ring"
          >
            Robyn & Angelo
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNavClick(link.href)}
                data-testid={link.testId}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors focus-ring"
              >
                {link.label}
              </button>
            ))}
            <Link
              to="/farm-guidelines"
              onClick={() => setIsOpen(false)}
              data-testid="nav-link-farm-guidelines"
              className={`flex items-center gap-1.5 text-sm font-medium transition-colors focus-ring ${
                location.pathname === '/farm-guidelines' ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <TreePine className="w-3.5 h-3.5" />
              Farm Guide
            </Link>
          </div>

          {/* Mobile Navigation */}
          <div className="md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  data-testid="nav-open-menu-button"
                >
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-64">
                <div className="flex flex-col gap-6 mt-8">
                  {navLinks.map((link) => (
                    <button
                      key={link.href}
                      onClick={() => handleNavClick(link.href)}
                      data-testid={link.testId}
                      className="text-lg font-medium text-foreground hover:text-primary transition-colors text-left focus-ring"
                    >
                      {link.label}
                    </button>
                  ))}
                  <Link
                    to="/farm-guidelines"
                    onClick={() => setIsOpen(false)}
                    data-testid="nav-link-farm-guidelines-mobile"
                    className="flex items-center gap-2 text-lg font-medium text-foreground hover:text-primary transition-colors text-left focus-ring"
                  >
                    <TreePine className="w-4 h-4" />
                    Farm Guide
                  </Link>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
